import {
    FETCH_MEDICINES_LIST_REQUEST,
    FETCH_MEDICINES_LIST_SUCCESS,
    FETCH_MEDICINES_LIST_FAILURE,
  } from "./FetchMedicinesListTypes";
  
  const initialState = {
    loading: false,
    medicinesList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MEDICINES_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_MEDICINES_LIST_SUCCESS:
        return {
          loading: false,
          medicinesList: action.payload,
          error: "",
        };
      case FETCH_MEDICINES_LIST_FAILURE:
        return {
          loading: false,
          medicinesList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  